import { createApp } from 'vue'
import App from './App.vue'
import router from './router'

// import './assets/main.css';

// Import Bootstrap CSS
import 'bootstrap/dist/css/bootstrap.min.css'

// Import Bootstrap JS Bundle (includes Popper) - needed for Offcanvas, Dropdowns etc.
import 'bootstrap/dist/js/bootstrap.bundle.min.js'

// Your optional custom CSS overrides (can be empty initially)
import './assets/main.css'

import './registerServiceWorker'
createApp(App).use(router).mount('#app')
